<template>
  <ul class="nav nav-tabs">
    <li :class="{ active: isActiveTab('Events') }">
      <router-link
        :to="{ name: 'Events' }"
        data-toggle="tab"
        data-target="#events"
        >{{ $label("event.events_tab", "Events") }}</router-link
      >
    </li>
    <li
      :class="{
        active:
          isActiveTab('EventInstructors') ||
          isActiveTab('NewEventInstructor') ||
          isActiveTab('EventInstructorDetails')
      }"
    >
      <router-link
        :to="{ name: 'EventInstructors' }"
        data-toggle="tab"
        data-target="#coaches"
        >{{ $label("event.instructors_tab", "Instructors") }}</router-link
      >
    </li>
    <li
      :class="{
        active:
          isActiveTab('EventVenues') ||
          isActiveTab('NewEventVenue') ||
          isActiveTab('EventVenueDetails')
      }"
    >
      <router-link
        :to="{ name: 'EventVenues' }"
        data-toggle="tab"
        data-target="#external-venues"
        >{{
          $label("event.external_venues_tab", "External venues")
        }}</router-link
      >
    </li>
    <li
      :class="{
        active:
          isActiveTab('EventCategories') ||
          isActiveTab('NewEventCategory') ||
          isActiveTab('EventCategoryDetails')
      }"
    >
      <router-link
        :to="{ name: 'EventCategories' }"
        data-toggle="tab"
        data-target="#categories"
        >{{ $label("event.categories_tab", "Categories") }}</router-link
      >
    </li>
    <li :class="{ active: isActiveTab('EventSettings') }">
      <router-link
        :to="{ name: 'EventSettings' }"
        data-toggle="tab"
        data-target="#settings"
        >{{ $label("event.settings_tab", "Settings") }}</router-link
      >
    </li>
  </ul>
</template>

<script>
export default {
  name: "NavigationTabs",

  methods: {
    isActiveTab(tab) {
      return this.$route.name == tab;
    }
  }
};
</script>

<style scoped></style>
